import dayjs from "dayjs";

// https://day.js.org/docs/en/display/format

/** Nov 2024 (UTC-based) */
export function jan2025(date: Date | string): string {
  return dayjs(date).tz("UTC").format("MMM YYYY");
}

/** Nov 1st 2024 (UTC-based) */
export function jan1st2025(date: Date | string): string {
  return dayjs(date).tz("UTC").format("MMM Do YYYY");
}

/** 2024-11-01 (UTC-based) */
export function isoString(date: Date | string): string {
  return dayjs(date).tz("UTC").format("YYYY-MM-DD");
}

/** date to jd */
export function jd(date: Date): number {
  // https://stackoverflow.com/questions/11759992/calculating-jdayjulian-day-in-javascript
  return date.getTime() / 86400000 + 2440587.5;
}

/** short date range string **/
export function dateRange(beginDate: Date | string, endDate: Date | string): string {
  const [b, e] = [dayjs(beginDate).tz("UTC"), dayjs(endDate).tz("UTC")];
  const [by, ey] = [b.year(), e.year()];

  let fmt;
  let efmt;
  let ystr = "";
  if (by === ey) {
    // Jan 3rd-Feb 4th,
    fmt = "MMM Do";
    // unless the months match
    if (b.month() === e.month()) efmt = "Do";
    // append year if necessary
    if (by !== dayjs().year()) ystr = ` ${by}`;
  } else {
    fmt = "MMM Do YYYY";
  }

  return `${b.format(fmt)}-${e.format(efmt || fmt)}${ystr}`;
}
